import {
    clearRestaurant,
    getDetailRestaurant,
    getDetailRestaurantSuccess,
    getMyRestaurant,
    getMyRestaurantSuccess,
    setSelectionFood,
} from '@store/actions/restaurant';
import { createFailureActionType, createReducer } from '@store/utils';

const initialState = {
    setSelectionFood: [],
};

const restaurantReducer = createReducer(
    {
        reducerName: 'restaurant',
        initialState,
        // storage: true,
        storage: false,
    },
    {
        [getMyRestaurantSuccess.type]: (state, { payload }) => {
            state.myRestaurant = payload?.data?.content || null;
        },
        [getDetailRestaurantSuccess.type]: (state, { payload }) => {
            state.detailRestaurant = payload?.data || payload?.payload?.data || null;
        },
        [setSelectionFood.type]: (state, { payload }) => {
            state.selectedFood = payload || [];
        },
        [getDetailRestaurant.type]: (state, { payload }) => {
            state.detailRestaurant = payload;
        },
        [clearRestaurant.type]: (state) => {
            state.myRestaurant = null;
            state.detailRestaurant = null;
            state.selectedFood = [];
        },
        [createFailureActionType(getDetailRestaurant.type)]: (state, { payload }) => {
            // eslint-disable-next-line
            //console.error({ payload });
        },
        [createFailureActionType(getMyRestaurant.type)]: (state, { payload }) => {
            // eslint-disable-next-line
            //console.error({ payload });
        },
    },
);

export default restaurantReducer;
